import WeightQuestion from './WeightQuestion';

export default WeightQuestion;
